import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/components/login/services/auth.service';
import { AUTH } from 'src/app/auth/components/login/types/login.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = sessionStorage.getItem(AUTH.TOKEN); // Get the token from session storage

    if (token && !this.isTokenExpired(token)) {
      // If token exists, allow access
      return true;
    } else {
      // If no token, redirect to login page or another route
      this.router.navigate(['/']);
      return false;
    }
  }

  isTokenExpired(token: string): boolean {
    // Decode the token and check the expiry time
    const expiry = JSON.parse(atob(token.split('.')[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
}
